<reb-ngx-navbar [collectionOfItems]="collectionOfItems" (emitNavbarStatus)="getNavbarStatus($event)"></reb-ngx-navbar>